import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { Card, Tabs } from "@mui/material";
import AdduserLic from "./tab-panel/add-user-lic";
import Reports from "./tab-panel/reports";
import Roles from "./tab-panel/roles";
import { userIsRole } from "../../utils/user-is-role";
import { UserRole } from "../../enums/enum";
import { useAppSelector } from "../../Hooks";
import { getUserInfo } from "../../store/user-process/selector";
import OperatorProcessingRequests from "./tab-panel/operator-processing-requests";
import PageLayout from "../../Components/page-layout/PageLayout";

export default function Admmin() {
  const [value, setValue] = React.useState("1");
  const userInfo = useAppSelector(getUserInfo);
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <PageLayout title="Админ панель" maxWidth="xl">
      <Card>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider", px: 1 }}>
            <Tabs value={value} onChange={handleChange} indicatorColor="primary" textColor="primary" variant="scrollable" aria-label="Разделы админ панели">
              {(userIsRole(userInfo, UserRole.Operator) || userIsRole(userInfo, UserRole.Admin)) && <Tab label="Привязка лицевых счетов" value="1" />}
              {(userIsRole(userInfo, UserRole.Admin) || userIsRole(userInfo, UserRole.OperatorAdmin)) && <Tab label="Отчеты" value="2" />}
              {userIsRole(userInfo, UserRole.Admin) && <Tab label="Управление ролями" value="3" />}
              {(userIsRole(userInfo, UserRole.Operator) || userIsRole(userInfo, UserRole.Admin)) && <Tab label="Обращения" value="4" />}
            </Tabs>
          </Box>
          <TabPanel value="1">
            <AdduserLic />
          </TabPanel>
          <TabPanel value="2">
            <Reports />
          </TabPanel>
          <TabPanel value="3">
            <Roles />
          </TabPanel>
          <TabPanel value="4">
            <OperatorProcessingRequests />
          </TabPanel>
        </TabContext>
      </Card>
    </PageLayout>
  );
}
